import { Route, Routes } from "react-router-dom";
import "./App.css";
// import SAMPLE_BLOGS from "./data/blogs";

import { useEffect, useState } from "react";
import BlogDetail from "./components/BlogCard/BlogDetails";
import Navbar from "./components/Navbar/Navbar";
import ProductPage from "./components/ProductPage/ProductPage";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";
import BlogPage from "./pages/BlogPage";
import CartPage from "./pages/CartPage";
import ContactPage from "./pages/ContactPage";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";

// sample blogs (keep your actual import if exists)
export default function App() {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cartData");
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchBlogs = async () => {
      try {
        const res = await fetch(
          "https://nastyauthenticbackend.onrender.com/api/blogs",
        );

        console.log(res);

        const data = await res.json();

        if (!data.success) {
          alert(data.message);
          return;
        }

        if (isMounted) {
          console.log("successfully retrieved blogs");
          setBlogs(data.blogs);
        }
        console.log(data);
      } catch (e) {
        console.log("Error occurred in fetching blogs:", e);
      }
    };

    fetchBlogs();

    return () => {
      isMounted = false;
    };
  }, []);

  const addToCart = (product) => {
    setCart((prev) => {
      const existing = prev.find((i) => i.id === product.id);

      if (existing) {
        return prev.map((i) =>
          i.id === product.id ? { ...i, qty: i.qty + 1 } : i,
        );
      }

      return [...prev, { ...product, qty: 1 }];
    });
  };

  const removeFromCart = (id) => {
    setCart((prev) => prev.filter((i) => i.id !== id));
  };

  const cartCount = cart.reduce((sum, i) => sum + i.qty, 0);

  useEffect(() => {
    try {
      localStorage.setItem("cartData", JSON.stringify(cart));
    } catch (e) {
      console.log("Error occured :", e);
    }
  }, [cart]);

  // const renderPage = () => {
  //   switch (page) {
  //     case "products":
  //       return <ProductsPage onProductClick={setSelectedProduct} />;

  //     case "blog":
  //       return <BlogPage blogs={blogs} />;

  //     case "about":
  //       return <AboutPage />;

  //     case "contact":
  //       return <ContactPage />;

  //     case "cart":
  //       return <CartPage cart={cart} onRemove={removeFromCart} />;

  //     case "admin":
  //       return (
  //         <AdminPage
  //           blogs={blogs}
  //           setBlogs={setBlogs}
  //           setPage={handleSetPage}
  //         />
  //       );

  //     default:
  //       return <HomePage setPage={handleSetPage} />;
  //   }
  // };

  return (
    <div className="app">
      <Navbar cartCount={cartCount} />

      {/* {selectedProduct && (
        <ProductModal
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
          onAddToCart={addToCart}
        />
      )} */}

      <Routes>
        <Route path="/" element={<HomePage blogs={blogs} />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route
          path="/products/:id"
          element={<ProductPage onAddToCart={addToCart} />}
        />
        <Route path="/blog" element={<BlogPage blogs={blogs} />} />
        <Route path="/blog/:slug" element={<BlogDetail blogs={blogs} />} />

        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route
          path="/cart"
          element={<CartPage cart={cart} onRemove={removeFromCart} />}
        />
        <Route
          path="/admin"
          element={<AdminPage blogs={blogs} setBlogs={setBlogs} />}
        />
      </Routes>

      {/* {renderPage()} */}

      <footer
        style={{
          padding: "40px",
          borderTop: "1px solid #111",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: 11, letterSpacing: "0.1em" }}>
          © 2025 NASTY AUTHENTIC
        </span>
        <span style={{ fontSize: 11, letterSpacing: "0.1em" }}>
          RAW. REAL. AUTHENTIC.
        </span>
      </footer>
    </div>
  );
}
